import { Tooltip } from '@sgme/ui';
import { useIntl } from 'react-intl';

export function PinnedExtra({ isPinned, onClick }: { isPinned: boolean; onClick: () => void }) {
  const { formatMessage } = useIntl();

  if (!isPinned) {
    return undefined;
  }

  function handleClick() {
    onClick();
  }

  return (
    <div>
      <Tooltip
        position="right"
        contents={formatMessage({ id: 'flexiForwardTile.mainFields.deltaHedge.pin.tooltip.message' })}
      >
        <button
          data-e2e="pin-button"
          onClick={handleClick}
          type="button"
          className="btn btn-sm btn-icon btn-flat-primary"
        >
          <i className="icon icon-sm cursor-default line-height-1 text-secondary">push_pin</i>
        </button>
      </Tooltip>
    </div>
  );
}
